<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent width="460">
      <v-card>
        <v-card-title class="title justify-space-between">
          <div>Add Stock Report</div>
          <v-spacer></v-spacer>
          <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="mt-5">
          <v-form ref="form">
            <div class="upload-container mb-4">
              <input
                type="file"
                id="upload-report"
                accept="application/pdf"
                @change="handleFileUpload"
              />
              <label for="upload-report">
                <div class="upload-box">
                  <!-- <img src="upload-icon.svg" alt="upload icon" class="upload-icon"> -->
                  <v-icon v-if="!pdfUploaded">mdi-tray-arrow-up</v-icon>
                  <v-img
                    :src="pdfIconPath"
                    v-if="pdfUploaded"
                    class="pdf-icon"
                  ></v-img>
                  <p>
                    {{ pdfUploaded ? "PDF Uploaded" : "Upload Report PDF" }}
                  </p>
                </div>
              </label>
            </div>
            <div>Stock Name</div>
            <v-autocomplete
              placeholder="Select Security"
              dense
              hide-no-data
              outlined
              :rules="[rules.required]"
              :items="securities"
              :item-text="getItemText"
              item-value="id"
              v-model="securityData"
              @keyup="(e) => getSecurity(e.target.value)"
            >
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <div>
                  <div>{{ data.item.symbol }}:{{ data.item.exchange }}</div>
                  <div class="security_name__class">
                    {{ data.item.name }}
                  </div>
                </div>
              </template></v-autocomplete
            >
            <div>
              <div class="d-flex">
                <div>This report is valid for</div>
                <v-spacer></v-spacer>
                <div>
                  Valid till
                  <span class="blue--text">{{ formattedValidTill }}</span>
                </div>
              </div>
              <v-text-field
                placeholder="Enter number of month(s)"
                suffix="Month(s)"
                outlined
                dense
                v-model="valid_till"
                :rules="[rules.required, rules.number]"
              ></v-text-field>
            </div>
            <div class="d-flex">
              <div class="mr-3">
                <div>Actual Price</div>
                <v-text-field
                  placeholder="Enter Price"
                  outlined
                  dense
                  v-model="price"
                  :rules="[rules.required, rules.number]"
                ></v-text-field>
              </div>
              <div>
                <div>Discounted Price</div>
                <v-text-field
                  placeholder="Enter Price"
                  outlined
                  dense
                  v-model="discount_price"
                ></v-text-field>
              </div>
            </div>
            <div>Enter Description</div>
            <v-textarea
              placeholder="Enter Description"
              outlined
              rows="2"
              v-model="description"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions v-if="!$vuetify.breakpoint.xsOnly">
          <v-btn
            class="text-none"
            color="primary"
            outlined
            @click="closeDialog"
            width="210"
            >Back</v-btn
          >
          <v-btn
            class="text-none"
            color="primary"
            @click="uploadReport"
            width="210"
            >Save</v-btn
          >
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn class="text-none" color="primary" @click="uploadReport" block
            >Save</v-btn
          >
        </v-card-actions>
        <!-- <v-btn @click="getSecurity">btn</v-btn> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import RULES from "@/common/fieldRules";
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import Axios from "@/api/BaseAxios";
export default {
  name: "UploadReportDialog",
  data() {
    return {
      rules: RULES,
      pdfIconPath: require("@/assets/images/trending/pdf_img.png"),
      pdfUploaded: false,
      price: null,
      discount_price: null,
      report_pdf: null,
      description: "",
      valid_till: null,
      securities: [],
      security: "",
      securityData: null,
      baseDate: new Date(),
      formattedValidTill: "",
    };
  },
  computed: {
    show() {
      return this.$store.state.ResearchReport.uploadReport.show;
    },
  },
  watch: {
    valid_till(newVal) {
      this.calculateValidTillDate(newVal);
    },
  },
  methods: {
    // ...mapActions({
    //   snackBar: "snackBar/showSnack",
    // }),
    closeDialog() {
      this.report_pdf = null;
      this.$store.commit("ResearchReport/toggleUploadReportModal", {
        show: false,
      });
      this.pdfUploaded = false;
      this.$refs.form.reset();
    },

    calculateValidTillDate(months) {
      // Check if the input is valid and greater than 0
      if (months && months > 0) {
        // Create a new date object from the base date
        let validDate = new Date(this.baseDate);
        // Add the number of months to the current date
        validDate.setMonth(validDate.getMonth() + parseInt(months));
        // Format the new date as required (e.g., 'Month Year')
        this.formattedValidTill = validDate.toLocaleString("default", {
          month: "long",
          year: "numeric",
        });
      } else {
        // If input is invalid, reset the formatted date
        this.formattedValidTill = "";
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.pdfUploaded = true;
        this.report_pdf = file;
        event.target.value = null;
      } else {
        this.pdfUploaded = false;
        this.report_pdf = null;
      }
    },
    getItemText(item) {
      return `${item.symbol}:${item.exchange}`;
    },
    getSecurity(val) {
      if (!val || val.length == 0) {
        this.securities = [];
        return;
      }

      const successHandler = (res) => {
        this.securities = res.data;
      };
      const errorHandler = () => {};
      Axios.request_GET(
        `api/trade/security_search/${val}`,
        // `api/trade/security_search/`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    uploadReport() {
      if (this.$refs.form.validate()) {
        const onSuccess = (res) => {
          this.report_pdf = null;
          this.$store.commit("ResearchReport/toggleUploadReportModal", {
            show: false,
          });
          this.pdfUploaded = false;
          this.$refs.form.reset();
          this.snackBar({
            text: `${res.data.message}`,
            color: "success",
            timeout: 4500,
          });
        };
        const onFailure = () => {};
        const formData = new FormData();
        if (this.discount_price !== null) {
          formData.append("discount_price", this.discount_price);
        }
        if (this.description !== "") {
          formData.append("description", this.description);
        }
        formData.append("price", this.price);
        formData.append("report_pdf", this.report_pdf); // Append the PDF file to FormData
        formData.append("stock", this.securityData);
        formData.append("valid_till", this.valid_till);
        newAxios("post", apiUrl.UPLOAD_RESEARCH_REPORT, {
          data: formData,
          onSuccess,
          onFailure,
          isTokenRequired: true,
        });
      }
    },
  },
};
</script>
<style scoped>
.title {
  color: #fff;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.625rem;
  /* 130% */
  background: var(--Primary-Blue, #2d8cff);
}

.img {
  height: 64px;
  width: 64px;
}

.head-text {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 800;
  line-height: 30px;
  color: #333333;
}

.text {
  font-family: Avenir;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  color: #333333;
}

.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

#upload-report {
  display: none;
}

.upload-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  border: 2px dashed #cccccc;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s;
  padding-top: 20px;
}

.upload-box:hover {
  background-color: #f9f9f9;
}

.upload-icon {
  width: 30px;
  margin-bottom: 10px;
}

.upload-box p {
  font-size: 14px;
  color: #666;
}

.pdf-icon {
  width: 50px;
  height: auto;
}
.security_name__class {
  color: #333333de;
  font-weight: 500;
  font-size: 13px;
  line-height: 17.76px;
}
</style>
